const Gbx = {
  symbol: 'gbx',
  color: '#000',
  plainIcon: c => {
    return `<path  fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.301-20.994h-4.7c-.995 0-2.141.325-3.054.973C6.717 12.851 6 14.217 6 16.003s.717 3.152 1.945 4.024a5.447 5.447 0 0 0 3.053.973H13v-2.06h-2c-.61 0-1.361-.214-1.92-.61C8.386 17.838 8 17.102 8 16.003s.387-1.835 1.08-2.327a3.507 3.507 0 0 1 1.92-.61h4.7zm-5 6.182H13.7V21h2v-5.873h-5zM19 13.06h5v5.878h-5.002v-5.872h-2V21H26V11h-7.002z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#1666af" r="16"/><path d="M15.699 11.006v2.06h-4.7c-.61 0-1.361.214-1.92.61-.693.492-1.08 1.229-1.08 2.327s.387 1.835 1.08 2.327c.559.396 1.31.61 1.92.61h2V21h-2a5.448 5.448 0 0 1-3.054-.973C6.717 19.155 6 17.789 6 16.003s.717-3.152 1.945-4.024a5.447 5.447 0 0 1 3.053-.973zm-5 6.182v-2.06h5V21H13.7v-3.812zM19 13.06V11h7v10h-9.002v-7.933h2v5.872H24v-5.878z" fill="#fff" fill-rule="nonzero"/></g>`;
  }
};
export default Gbx;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/gbx.js
// module id = null
// module chunks = 